import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { BarPeriodoComponent } from './bar-periodo/bar-periodo.component';
import { FiltroCursoComponent } from './filtro-curso/filtro-curso.component';
import { FiltroMateriaComponent } from './filtro-materia/filtro-materia.component';
import { FiltroMaterialModule } from './filtro-material.module';
import { FiltroNombreComponent } from './filtro-nombre/filtro-nombre.component';
import { FiltroPeriodoParentComponent } from './filtro-periodo-parent/filtro-periodo-parent.component';
import { FiltroPeriodoComponent } from './filtro-periodo/filtro-periodo.component';
import { SelectMcpComponent } from './select-mcp/select-mcp.component';
import { FiltroEffects } from './_state/filtro.effects';
import { filtroReducer } from './_state/filtro.reducer';
import { ToolbarRequisicionesComponent } from './toolbar-requisiciones/toolbar-requisiciones.component';
import { FiltroEstadoComponent } from './filtro-estado/filtro-estado.component';
import { PreguntaComponent } from './pregunta/pregunta.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FiltroSesionComponent } from './filtro-sesion/filtro-sesion.component';
import { SelectValuePipe } from './_pipes/select-value.pipe';
import { FiltroCursoSalonComponent } from './filtro-curso-salon/filtro-curso-salon.component';
import { SelectCursoSalonComponent } from './select-curso-salon/select-curso-salon.component';
import { FiltroCursoNuevoPipe } from './_pipes/filtro-curso-nuevo.pipe';

import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { GlmCkeditorClassicComponent } from './glm-ckeditor-classic/glm-ckeditor-classic.component';
import { GlmCkeditorDecoupledComponent } from './glm-ckeditor-decoupled/glm-ckeditor-decoupled.component';
import { PhotoBookComponent } from './photo-book/photo-book.component';
import { PhotoDialogComponent } from './photo-book/photo-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FiltroMaterialModule,

        CKEditorModule,

        StoreModule.forFeature('filtroBuscar', filtroReducer),
        EffectsModule.forFeature([FiltroEffects]),
    ],
    exports: [
        BarPeriodoComponent,
        FiltroMateriaComponent,
        FiltroCursoComponent,
        FiltroCursoSalonComponent,
        FiltroPeriodoParentComponent,
        FiltroPeriodoComponent,
        FiltroSesionComponent,
        FiltroNombreComponent,
        FiltroEstadoComponent,
        GlmCkeditorClassicComponent,
        GlmCkeditorDecoupledComponent,
        PreguntaComponent,
        SelectCursoSalonComponent,
        SelectMcpComponent,
        ToolbarRequisicionesComponent,
    ],
    declarations: [
        BarPeriodoComponent,
        FiltroMateriaComponent,
        FiltroCursoComponent,
        FiltroCursoSalonComponent,
        FiltroPeriodoComponent,
        FiltroPeriodoParentComponent,
        FiltroSesionComponent,
        FiltroNombreComponent,
        FiltroEstadoComponent,
        GlmCkeditorClassicComponent,
        GlmCkeditorDecoupledComponent,
        PreguntaComponent,
        SelectCursoSalonComponent,
        SelectMcpComponent,
        ToolbarRequisicionesComponent,
        SelectValuePipe,
        FiltroCursoNuevoPipe,
    ],
    providers: [],
})
export class FiltroModule { }
